module.exports = __webpack_public_path__ + "static/media/rocket_assembly_bg.beb335ae.jpg";